import { UpdateWellbeingCheckSettingsQueryArg } from '../types/query-arg';
import { UpdateWellbeingCheckSettingsQueryBody } from '../types/query-body';

export const updateWellbeingCheckSettingsQueryBody = ({
  organisation,
  wellbeingCheckSettings,
}: UpdateWellbeingCheckSettingsQueryArg): UpdateWellbeingCheckSettingsQueryBody => ({
  organisationId: organisation.id,
  wellbeingCheckSettings,
});
